module.exports = __webpack_public_path__ + "icon-marker-violet.svg?363656771d8222181d0e196b0e590954";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-marker-violet.svg
// module id = 34
// module chunks = 0